module.exports = __webpack_public_path__ + "img/avatar1.d3ad852f.png";